import React, { useState, useContext, useEffect } from "react";
import {
  Head,
  Notification,
  Checkbox,
  FormGroup,
  FilePicker,
  Input,
  Select,
  Switch,
  Button,
  ActionButton
} from "xsolla-uikit";
// import PAContentBlock from "./PAContentBlock";
// import { ContextConsumer, GlobalContext } from '../PA';

// import { KeyContext } from "./PAgameKeys";

// import SelectExample from "../SelectExample";
import { IntlProvider } from "react-intl";

export default function PAgameKeysWidg({
  controls,
  pre = false,
  name = "My Game",
  sku = "my_game_123",
  price = "9.99",
  cur = "USD"
}) {
  const [state, setState] = useState({});

  // let context = useContext(GlobalContext);

  return (

      <div className="xsui-content-block__entry">

        {/* <Head>Game store widget</Head> */}


        {/* <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-md">
        <div className="xsui-form-group__entry">
          <div className="xsui-breadcrumbs">
            <div className="xsui-breadcrumbs_entry">
              <div className="xsui-breadcrumbs_item">
                <a className="xsui-breadcrumbs_label">Distribution</a>
              </div>
            </div>
          </div>
        </div>
      </div> */}

        {/* <div>
        <div className="ui-navigation ui-navigation--size-lg ui-navigation--bordered">
          <div className="ui-navigation__menu">
            <div className="ui-navigation__section">
              <a className="ui-navigation__item" aria-current="false" data-id="nav.basic" href="/2340/projects/38954/storefront/pay2play/3998">Basic settings</a>
              <a className="ui-navigation__item" aria-current="false" data-id="nav.price" href="/2340/projects/38954/storefront/pay2play/3998/price-settings">Price settings</a>
              <a className="ui-navigation__item" aria-current="false" data-id="nav.keys" href="/2340/projects/38954/storefront/pay2play/3998/keys-management">Keys &amp; Distributives</a>
              <a className="ui-navigation__item ui-navigation__item--active" aria-current="true" data-id="nav.widget" href="/2340/projects/38954/storefront/pay2play/3998/widget-customization">Widget customization</a>
            </div>
            <div className="ui-navigation__section ui-navigation__section--actions" />
          </div>
        </div>
      </div> */}

        {/* <div className="banner-container">
        <div className="submit-status submit-status--alert submit-status--no-icon">
          <span>This module can't be integrated until <a aria-current="false" href="/2340/projects/38954/edit/webhooks/pay2play">webhooks</a> are fully configured and tested. Alternatively, you can <a aria-current="false" href="/2340/projects/38954/edit/advanced">enable tokenless integration</a>.</span>
        </div>
      </div> */}

        {/* <PAContentBlock
              title="General Settings"
        border={true}> */}

        <FormGroup indentation="lg">

          <div
            className="p2p-widget__sample"
            id="p2p-widget__sample"
            style={{ width: "100%", padding: 20, backgroundColor: "#fafafa" }}
          >

<div id="XS-pay2play-widget-3" className="widget-block-item">
            <div
              className="xpay2Play-widget xpay2Play-widget__tiny xpay2Play-widget__dark"
              data-reactid=".2"
            >
              <div
                className="xpay2Play-widget-game-logo xpay2Play-widget-game-logo__dark"
                style={{
                  backgroundImage:
                    "url(https://res.cloudinary.com/maiik/image/upload/c_thumb,w_200,g_face/v1549624607/Xsolla/HomePage_Hero_Illustration_1440_oabqmk.jpg)"
                }}
                data-reactid=".2.0"
              />
              <div
                className="xpay2Play-widget-button-block xpay2Play-widget-button-block__dark"
                data-reactid=".2.1"
              >
                <div
                  className="xpay2Play-widget-game-name xpay2Play-widget-game-name__dark "
                  data-reactid=".2.1.0"
                >
                  {name}
                </div>
                <button
                  className="xpay2Play-widget-payment-button  xpay2Play-widget-payment-button__blue"
                  data-reactid=".2.1.1"
                  style={{fontSize: 14}}
                >
                  <span
                    className="xpay2Play-widget-payment-button-amount"
                    data-reactid=".2.1.1.0"
                  >
                    <span data-reactid=".2.1.1.0.0">
                      <span
                        className="translate-message"
                        data-reactid=".2.1.1.0.0.0"
                      >
                        {!pre ? `Buy Now` : `Pre-Order`} &nbsp; | &nbsp; {cur}{" "}
                      </span>
                      <span
                        className="translate-message-amount"
                        data-reactid=".2.1.1.0.0.1"
                      >
                        <span className="formatted-currency ">$0.99</span>
                      </span>
                    </span>
                  </span>
                </button>
                <div
                  className="xpay2Play-widget-gradient-block xpay2Play-widget-gradient-block__dark"
                  data-reactid=".2.1.2"
                />
                <div
                  className="xpay2Play-widget-tip  xpay2Play-widget-tip__dark "
                  data-reactid=".2.1.3"
                >
                  <div
                    className="xpay2Play-widget-tip-txt"
                    data-reactid=".2.1.3.0"
                  >
                    <div
                      className="xpay2Play-widget-tip-img xpay2Play-widget-tip-img__dark"
                      data-reactid=".2.1.3.0.0"
                    >
                      <svg
                        className="xpay2Play-widget-tip-icon"
                        width={12}
                        height={12}
                        viewBox="0 0 24 24"
                        data-reactid=".2.1.3.0.0.0"
                      >
                        <path
                          d="M12.1,18.55L12,18.65L11.89,18.55C7.14,14.24 4,11.39 4,8.5C4,6.5 5.5,5 7.5,5C9.04,5 10.54,6 11.07,7.36H12.93C13.46,6 14.96,5 16.5,5C18.5,5 20,6.5 20,8.5C20,11.39 16.86,14.24 12.1,18.55M16.5,3C14.76,3 13.09,3.81 12,5.08C10.91,3.81 9.24,3 7.5,3C4.42,3 2,5.41 2,8.5C2,12.27 5.4,15.36 10.55,20.03L12,21.35L13.45,20.03C18.6,15.36 22,12.27 22,8.5C22,5.41 19.58,3 16.5,3Z"
                          data-reactid=".2.1.3.0.0.0.0"
                        />
                      </svg>
                    </div>
                    <div
                      className="xpay2Play-widget-tip-button"
                      data-reactid=".2.1.3.0.1"
                    >
                      <span
                        className="translate-message"
                        data-reactid=".2.1.3.0.1.0"
                      >
                        Tip the developer
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  className="xpay2Play-widget-tips-list-block xpay2Play-widget-tips-list-block__hide"
                  data-reactid=".2.1.4"
                >
                  <div
                    className="xpay2Play-widget-tips-list xpay2Play-widget-tips-list__dark"
                    data-reactid=".2.1.4.0"
                  >
                    <div
                      className="xpay2Play-widget-tips-list-item xpay2Play-widget-tips-list-item__dark "
                      data-reactid=".2.1.4.0.0:$0"
                    >
                      <a
                        className="xpay2Play-widget-tips-list-item-amount xpay2Play-widget-tips-list-item-amount__dark"
                        data-reactid=".2.1.4.0.0:$0.0"
                      >
                        <span
                          className="formatted-currency "
                          data-reactid=".2.1.4.0.0:$0.0.0"
                        >
                          $1
                        </span>
                      </a>
                    </div>
                    <div
                      className="xpay2Play-widget-tips-list-item xpay2Play-widget-tips-list-item__dark "
                      data-reactid=".2.1.4.0.0:$1"
                    >
                      <a
                        className="xpay2Play-widget-tips-list-item-amount xpay2Play-widget-tips-list-item-amount__dark"
                        data-reactid=".2.1.4.0.0:$1.0"
                      >
                        <span
                          className="formatted-currency "
                          data-reactid=".2.1.4.0.0:$1.0.0"
                        >
                          $3
                        </span>
                      </a>
                    </div>
                    <div
                      className="xpay2Play-widget-tips-list-item xpay2Play-widget-tips-list-item__dark "
                      data-reactid=".2.1.4.0.0:$2"
                    >
                      <a
                        className="xpay2Play-widget-tips-list-item-amount xpay2Play-widget-tips-list-item-amount__dark"
                        data-reactid=".2.1.4.0.0:$2.0"
                      >
                        <span
                          className="formatted-currency "
                          data-reactid=".2.1.4.0.0:$2.0.0"
                        >
                          $5
                        </span>
                      </a>
                    </div>
                    <div
                      className="xpay2Play-widget-tips-list-item xpay2Play-widget-tips-list-item__close"
                      data-reactid=".2.1.4.0.$-1"
                    >
                      <a
                        className="xpay2Play-widget-tips-list-item-link-close xpay2Play-widget-tips-list-item-link-close__dark"
                        data-reactid=".2.1.4.0.$-1.0"
                      >
                        <svg
                          className="xpay2Play-widget-tips-list-item-icon xpay2Play-widget-tips-list-item-icon__dark"
                          width={14}
                          height={14}
                          viewBox="0 0 24 24"
                          data-reactid=".2.1.4.0.$-1.0.0"
                        >
                          <path
                            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                            data-reactid=".2.1.4.0.$-1.0.0.0"
                          />
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          </div>

          {/* <div className="p2p-widget__code"
            style={{ width: '100%', height: '140px', border: 0 }}
          >
          <pre>
            <code>{"\n"}{"      "}&lt;div id="XS-pay2play-widget"&gt;&lt;/div&gt;{"\n"}{"      "}&lt;script&gt;{"\n"}{"          "}var options = {"{"}{"\n"}{"              "}access_token: "6qpkslm6OeKa2JPVmSbbIwscaC2nldHZ",{"\n"}{"              "}theme : {"{"}{"\n"}{"                  "}foreground: "green",{"\n"}{"                  "}background: "light"{"\n"}{"              "}{"}"},{"\n"}{"              "}target_element: "#XS-pay2play-widget"{"\n"}{"          "}{"}"};{"\n"}{"          "}var s = document.createElement("script");{"\n"}{"          "}s.type = "text/javascript";{"\n"}{"          "}s.async = true;{"\n"}{"          "}s.src = "//static.xsolla.com/embed/pay2play/2.1.5/widget.min.js";{"\n"}{"          "}s.addEventListener("load", function (e) {"{"}{"\n"}{"              "}var widgetInstance = XPay2PlayWidget.create(options);{"\n"}{"          "}{"}"}, false);{"\n"}{"          "}var head = document.getElementsByTagName("head")[0];{"\n"}{"          "}head.appendChild(s);{"\n"}{"      "}&lt;/script&gt;{"\n"}{"      "}</code>
          </pre>
            <div className="p2p-widget__code__copy-button">
              <button
                // style={{
                //   backgroundColor: (props.keys) ? 'null' : '#c5d0db',
                //   border: (props.keys) ? 'auto' : '1px solid #c5d0db'
                // }}
                type="button"
                className="ui-form__button ui-form__button--default ui-form__button--normal ui-form__button--blue ui-form__button--inline undefined">
              <img src="//cdn.xsolla.net/publisher-v4/duplicate-single-white.858677.svg" />Copy widget code</button>
          </div>
        </div> */}
        </FormGroup>

        {!controls && (
          <React.Fragment>
            <FormGroup>

              <div className="ui-form__input-group ui-form__input-group--spaced">
                <FormGroup indentation="sm" label="Background color">
                  <Select
                    // disabled={this.disabled}
                    name=""
                    // size="sm"
                    options={[
                      { label: "Dark", value: "dark" },
                      { label: "Light", value: "light" }
                    ]}
                    // searchable={this.searchable}
                    // autosize={this.autosize}
                    // size={this.size}
                    input={{
                      name: "widgTheme",
                      value: "dark",
                      onChange: () => {
                        void 0;
                      }
                    }}
                  />
                </FormGroup>

                <FormGroup label="Button color">
                  <Select
                    // disabled={this.disabled}
                    name=""
                    options={[
                      { label: "Green", value: "dark" },
                      { label: "Red", value: "light" },
                      { label: "Purple", value: "purple" },
                      { label: "Custom", value: "custom" }
                    ]}
                    // searchable={this.searchable}
                    // autosize={this.autosize}
                    // size={this.size}
                    input={{
                      name: "widgTheme",
                      value: "dark",
                      onChange: () => {
                        void 0;
                      }
                    }}
                  />
                </FormGroup>
              </div>

              <div className="ui-form__input-group ui-form__input-group--spaced">
                <FormGroup
                  indentation="md"
                  label="Background image"
                  tooltip="What's this"
                >
                  {/*
            <ActionButton
              appearance="primary"
              icon="upload"
              // onClick=''
            >
            Background Image
          </ActionButton> */}

                  <div className="xsui-action-button xsui-action-button--appearance-primary">
                    <Button icon="upload" appearance="flatten">
                      {" "}
                      Upload
                    </Button>
                  </div>
                </FormGroup>

                <FormGroup
                  indentation="md"
                  label="Tipping"
                  tooltip="Lets players add a tip to the price of their game key, to show a little extra appreciation for the game’s developers. Fixed tip amounts are listed on the widget in local currencies. Default tips: US$1.00, US$3.00, US$5.00"
                >
                  <div style={{ padding: "8px 0 0 0" }}>
                    <Switch
                      name="switch_1"
                      input={{
                        value: true,
                        onChange: () => {
                          void 0;
                        }
                      }}
                    />
                  </div>
                </FormGroup>
              </div>
            </FormGroup>
          </React.Fragment>
        )}

        {/* </PAContentBlock> */}
      </div>

  );
}
